import { StateError } from './../../shared/state';
import { User } from '../../models/user';

export class AuthState {
	currentUser: User;
	access_token: string;
	refresh_token: string;
	// ID-8: the session of the app-local anonymous user, for as long as no Pro Pool ID login replaces it.
	anonymous_token: string;
	loading: boolean;
	location: {
		latitude: null,
		longitude: null
	};
	error: StateError;
}

export const initialAuthState: AuthState = {
	currentUser: null,
	access_token: null,
	refresh_token: null,
	anonymous_token: null,
	loading: true,
	location: {
		latitude: null,
		longitude: null
	},
	error: StateError.None,
};
